import React from 'react';

export  const InBasketButton = ({ onClick }) => (
    <button
        class="bg-scrollbarThumbActive text-[24px] h-[61px] sm:w-[346px] w-[260px]  text-white flex items-center justify-center rounded-[20px] transition-all duration-150 ease-in-out transform hover:scale-98 hover:bg-scrollbarThumbHover active:scale-95"
      onClick={onClick}
      tabIndex={0}
    >
      + в корзину
    </button>
  );